import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

import { Box, Flex } from 'Components/Base';

import { get } from '../../Base/constants';

const ContainerRating = styled(Flex)`
  border-radius: 8px;
  border: ${get(`colors.greyscale.grey4`)} 1px solid;
  overflow: hidden;
`;

const Selector = styled(Box)`
  flex-grow: 1;
  padding: 6px 0px;
  text-align: center;
  width: 8px;
  font-size: 12px;
  font-weight: 300;
  cursor: pointer;

  &:not(:first-child) {
    border-left: ${get(`colors.greyscale.grey4`)} 1px solid;
  }

  ${({ selected }) => css`
    background-color: ${selected ? get(`colors.warning`) : 'transparent'};
  `}
`;

const FeedbackRating = ({ value, ratings, onClick, ...props }) => {
  const handleOnClick = (rating) => onClick(rating);
  return (
    <ContainerRating {...props}>
      {ratings.map((rating) => (
        <Selector
          key={rating}
          role="button"
          selected={value === rating}
          onClick={() => {
            handleOnClick(rating);
          }}
        >
          {rating}
        </Selector>
      ))}
    </ContainerRating>
  );
};

FeedbackRating.propTypes = {
  value: PropTypes.string,
  ratings: PropTypes.arrayOf(PropTypes.number),
  onClick: PropTypes.func,
};

FeedbackRating.defaultProps = {
  ratings: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  onClick: (rating) => {},
};

export default FeedbackRating;
